<template>
    <v-dialog v-model="dialog" xwidth="500" persistent>
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text">
            Fecha de emision del certificado
          </v-card-title>
  
          <v-card-text> 
            <v-text-field label="Fecha" v-model="fecha" name="fecha" prepend-icon="mdi-account" type="date"></v-text-field>
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="cerrar()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </template>
  
  <script>
    export default {
      data() {
        return {
          dialog: false,
          fecha: null,
        };
      },
      methods: {
        openmodal() {
            this.dialog = true;
            const fecha = new Date();
            const formatoFecha = new Intl.DateTimeFormat('fr-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).format(fecha);
            this.fecha = formatoFecha; 
        },
        cerrar(){
            this.$emit('success', this.fecha)
            this.dialog = false;
        }
      },
    };
  </script>
  